import './RichDropdown.css';

import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { generateClassName } from './helpers';
import useB2BTranslation from './hooks/useB2BTranslation';

const CustomDropdownItem = ({ imageSrc, content }) => (
    <div style={{ display: 'flex', alignItems: 'center' }} className={generateClassName('rich-drop-down', '-custom-dropdown-item')} >
        <img src={imageSrc} alt="item" style={{ width: 50, height: 50, marginRight: 10 }}
            className={generateClassName('rich-drop-down', '-custom-dropdown-item-image')}
        />
        <div dangerouslySetInnerHTML={{ __html: content }}
            className={generateClassName('rich-drop-down', '-custom-dropdown-item-content')}
        />
    </div>
);

const RichDropdown = ({ items, inputLabel = null, selectedItem, handleChange, className = null }) => {
    const { t } = useB2BTranslation('b2b-common');
    return (
        <FormControl fullWidth className={generateClassName('rich-drop-down', '-container', className)}>
            <InputLabel id="rich-dropdown-label" className={generateClassName('rich-drop-down', '-input-label', className)}>{inputLabel ? inputLabel : t('Select Item')}</InputLabel>
            <Select
                variant="standard"
                labelId="rich-dropdown-label"
                value={selectedItem}
                onChange={handleChange}
                renderValue={(selected) => {
                    const item = items.find(i => i.value === selected);
                    return <CustomDropdownItem imageSrc={item.imageSrc} content={item.content} />;
                }}
                className={generateClassName('rich-drop-down', '-select', className)}
            >
                {items.map((item) => (
                    <MenuItem key={item.value} value={item.value} className={generateClassName('rich-drop-down', '-menu-item', className)} >
                        <CustomDropdownItem imageSrc={item.imageSrc} content={item.content} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
};

export default RichDropdown;